import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

import {
  FacialTypes,
  FacialInterface,
  FacialSettingsGetInterface,
  UserStatusInterface,
  UploadStatusInterface,
  FacialDailyResumeInterface,
  FacialDayDetailInterface,
} from './types';

// List Facial Recognition
export const listFacialRequest = (payload: { body: object }) =>
  action(FacialTypes.LIST_FACIAL_REQUEST, payload);

export const listFacialSuccess = (payload: {
  facialList: FacialInterface[];
  totalCount: number;
}) => action(FacialTypes.LIST_FACIAL_SUCCESS, payload);

export const listFacialFailure = () => action(FacialTypes.LIST_FACIAL_FAILURE);

export const lastValidationListFacialRequest = (payload: { body: object }) =>
  action(FacialTypes.LAST_VALIDATION_LIST_FACIAL_REQUEST, payload);

export const lastValidationListFacialSuccess = (payload: {
  lastValidationFacialList: FacialInterface[];
  totalCount: number;
}) => action(FacialTypes.LAST_VALIDATION_LIST_FACIAL_SUCCESS, payload);

export const lastValidationListFacialFailure = () =>
  action(FacialTypes.LAST_VALIDATION_LIST_FACIAL_FAILURE);

// Get Facial Recognition Settings
export const getSettingsRequest = (payload: object) =>
  action(FacialTypes.GET_SETTINGS_REQUEST, payload);

export const getSettingsSuccess = (payload: {
  facialSettingsData: FacialSettingsGetInterface;
}) => action(FacialTypes.GET_SETTINGS_SUCCESS, payload);

export const getSettingsFailure = () =>
  action(FacialTypes.GET_SETTINGS_FAILURE);

// Get Facial Recognition Upload Status
export const getUploadStatusRequest = (payload: object) =>
  action(FacialTypes.GET_UPLOAD_STATUS_REQUEST, payload);

export const getUploadStatusSuccess = (payload: {
  uploadStatusList: UploadStatusInterface[];
}) => action(FacialTypes.GET_UPLOAD_STATUS_SUCCESS, payload);

export const getUploadStatusFailure = () =>
  action(FacialTypes.GET_UPLOAD_STATUS_FAILURE);

// List Facial Daily Resume
export const listFacialDailyResumeRequest = (payload: object) =>
  action(FacialTypes.LIST_FACIAL_DAILY_RESUME_REQUEST, payload);

export const listFacialDailyResumeSuccess = (payload: {
  facialDailyResumeList: FacialDailyResumeInterface[];
  totalCount: number;
}) => action(FacialTypes.LIST_FACIAL_DAILY_RESUME_SUCCESS, payload);

export const listFacialDailyResumeFailure = () =>
  action(FacialTypes.LIST_FACIAL_DAILY_RESUME_FAILURE);

// List Facial Day Detail
export const listFacialDayDetailRequest = (payload: object) =>
  action(FacialTypes.LIST_FACIAL_DAY_DETAIL_REQUEST, payload);

export const listFacialDayDetailSuccess = (payload: {
  facialDayDetailList: FacialDayDetailInterface[];
  totalCount: number;
}) => action(FacialTypes.LIST_FACIAL_DAY_DETAIL_SUCCESS, payload);

export const listFacialDayDetailFailure = () =>
  action(FacialTypes.LIST_FACIAL_DAY_DETAIL_FAILURE);

// Update Facial Recognition Settings
export const updateSettingsRequest = (payload: object) =>
  action(FacialTypes.UPDATE_SETTINGS_REQUEST, payload);

export const updateSettingsSuccess = (payload: {
  facialSettingsData: FacialSettingsGetInterface;
}) => action(FacialTypes.UPDATE_SETTINGS_SUCCESS, payload);

export const updateSettingsFailure = () =>
  action(FacialTypes.UPDATE_SETTINGS_FAILURE);

// Get Facial Recognition User Status
export const getUserStatusRequest = (payload: object) =>
  action(FacialTypes.GET_USER_STATUS_REQUEST, payload);

export const getUserStatusSuccess = (payload: {
  userStatus: UserStatusInterface;
}) => action(FacialTypes.GET_USER_STATUS_SUCCESS, payload);

export const getUserStatusFailure = () =>
  action(FacialTypes.GET_USER_STATUS_FAILURE);

// Get Facial Recognition Update Approval Status
export const updateApprovalStatusRequest = (payload: object) =>
  asyncAction(FacialTypes.UPDATE_APPROVAL_STATUS_REQUEST, payload);

export const updateApprovalStatusSuccess = () =>
  action(FacialTypes.UPDATE_APPROVAL_STATUS_SUCCESS);

export const updateApprovalStatusFailure = () =>
  action(FacialTypes.UPDATE_APPROVAL_STATUS_FAILURE);

// Get Public Image URLs
export const getPublicImageRequest = (payload: {
  photoNames: string;
  containerName: string;
}) => action(FacialTypes.GET_PUBLIC_IMAGE_REQUEST, payload);

export const getPublicImageSuccess = (payload: { urls: string[] }) =>
  action(FacialTypes.GET_PUBLIC_IMAGE_SUCCESS, payload);

export const getPublicImageFailure = () =>
  action(FacialTypes.GET_PUBLIC_IMAGE_FAILURE);

// Get Last Public Image URLs
export const getLastPublicImageRequest = (payload: {
  items: FacialInterface[];
}) => action(FacialTypes.LAST_GET_PUBLIC_IMAGE_REQUEST, payload);

export const getLastPublicImageSuccess = (payload: { urls: Record<string, string> }) =>
  action(FacialTypes.LAST_GET_PUBLIC_IMAGE_SUCCESS, payload);

export const getLastPublicImageFailure = () =>
  action(FacialTypes.LAST_GET_PUBLIC_IMAGE_FAILURE);

// Current Card
export const currentCard = (payload: { cardIndex: number }) =>
  action(FacialTypes.CURRENT_CARD, payload);

// Set Selected Score
export const setSelectedScore = (payload: { scorePercent: number | string }) =>
  action(FacialTypes.SET_SELECTED_SCORE, payload);

// Set Selected Status
export const setSelectedStatus = (payload: { selectedStatus: number[] }) =>
  action(FacialTypes.SET_SELECTED_STATUS, payload);

// Set Selected Approval Status
export const setSelectedApprovalStatus = (payload: {
  selectedApprovalStatus: number[];
}) => action(FacialTypes.SET_SELECTED_APPROVAL_STATUS, payload);

// Chips
export const chipsList = (payload: { chipsList: any }) =>
  action(FacialTypes.CREATE_CHIPS_LIST, payload);

export const cleanChipsList = () => action(FacialTypes.CLEAN_CHIPS_LIST);

// Set Selected Start Date
export const setSelectedStartDate = (payload: { selectedStartDate: Date }) =>
  action(FacialTypes.SET_SELECTED_START_DATE, payload);

// Set Selected End Date
export const setSelectedEndDate = (payload: { selectedEndDate: Date }) =>
  action(FacialTypes.SET_SELECTED_END_DATE, payload);

// Set Selected Status
export const setSelectedValidationStatus = (payload: {
  selectedValidationStatus: number[];
}) => action(FacialTypes.SET_SELECTED_VALIDATION_STATUS, payload);
